import './empty-state.styles.css';

export type EmptyStateProps = {
	title: string;
	description?: string;
	imageSrc?: string;
	variant?: 'circle' | 'triangle';
	bgColor?: string;
};

const EmptyState: React.FC<EmptyStateProps> = ({
	title,
	description,
	imageSrc,
	variant,
	bgColor = 'bg-surfaceContainerLow',
}) => {
	return (
		<div className={`emptystate-container + ${bgColor}`}>
			{imageSrc ? (
				<img
					src={imageSrc}
					alt="Empty State"
					width={200}
					height={200}
				/>
			) : variant === 'circle' ? (
				<div className="emptystate-circle">
					<div className="emptystate-circle-inner">
						<span className="emptystate-icon">!</span>
					</div>
				</div>
			) : variant === 'triangle' ? (
				<div className="emptystate-triangle">
					<div className="emptystate-triangle-shape" />
					<div className="emptystate-triangle-inner" />
					<span className="emptystate-icon">!</span>
				</div>
			) : null}

			<h3 className="emptystate-title">{title}</h3>
			{description && (
				<p className="emptystate-description">{description}</p>
			)}
		</div>
	);
};

export default EmptyState;
